/** @format */

import React, { Component } from "react";

import { Link } from "react-router-dom";
import TituloEditarperfil from "./Titulo-editarperfil";
import ListaEestudiante from "./Lista-estudiante";
import ArrowBackIcon from "../assets/img/backarrow.svg";
import { right } from "@popperjs/core";
import { getStorage } from "../util/auth";

export default class Header extends Component {
  render() {
    const data = this.props.objData;
    const _isMobile = this.props.isMobile;
    const listStudents = this.props.objlistStudents;
    const activeAlummno = this.props.objActiveAlummno;
    const filter = this.props.page;
    const redirec = this.props.redir;
    const Title = this.props.Title;
    const ChangeStudentHandler = this.props.ChangeStudentHandler;
    let dataStorage = getStorage("studientActive");

    const handleChange = (selectedOption2) => {
      if (
        selectedOption2 &&
        Array.isArray(selectedOption2.students)
      ) {
        return selectedOption2.students.map((student) => ({
          value: student.Codigo,
          label: student.Nombres.toLowerCase(),
        }));
      }
    
      // Retornar opción por defecto, pero sin tocar localStorage
      return [{ value: 0, label: "Select" }];
    };
    
    const options = handleChange(data);

    const handleEstudiantechange = (selected) => {
      const rs = data.students.filter((s) => s.Codigo == selected.value);
      if (rs.length === 0) return;
      const objStudent = {
        Codigo: rs[0].Codigo,
        Nombres: rs[0].Nombres,
        Carrera: rs[0].Carrera,
        Foto: rs[0].Foto,
      };
      
      data.student = objStudent;
      activeAlummno();
    };
    return (
      <div>
        {filter == "E" ? (
          <div>
            <TituloEditarperfil
              nombreTitulo={"Estudiante"}
              isMobile={_isMobile}
            />
            <div className="divisor col-12"></div>
            <div className="contend-lista-estudiante">
              {listStudents == undefined
                ? ""
                : listStudents.map((student, i) => {
                    return (
                      <div
                        className="link-estudiante mt-4"
                        key={student.Codigo}
                      >
                        <Link
                          to="/curso"
                          onClick={() => {
                            ChangeStudentHandler(
                              student.Codigo,
                              student.Nombres,
                              student.Carrera,
                              student.Ciclo,
                              student.Foto
                            );
                          }}
                        >
                          <ListaEestudiante objStudents={student} />
                        </Link>
                      </div>
                    );
                  })}
            </div>
          </div>
        ) : (
          <div>
            <TituloEditarperfil
              nombreTitulo={Title}
              objactiveAlummno={data}
              isMobile={_isMobile}
              _redirec={redirec}
              _filter={filter}
            />
            <div className="divisor col-12"></div>
            <div className=" row justify-content-between">
              <div className="col-12 mt-4">
                <div className="row">
                  {!_isMobile ? (
                    <>
                      <div className="col-8">
                        <ListaEestudiante
                          objStudents={
                            data == undefined
                              ? ""
                              : data.student == undefined
                              ? ""
                              : data.student
                          }
                        />
                      </div>
                      {filter != "D" ? (
                        <div className="col-4">
                          <div className="form-group">
                            {options != undefined ? (
                              options.length != 1 ? (
                                <>
                                  <div
                                    style={{
                                      fontSize: "1.5ex",
                                      padding: "0 0 1.5% 0",
                                    }}
                                  >
                                    Cambiar de estudiante :
                                  </div>
                                  <select
                                    className="form-select selectActive"
                                    name="form-dept-select"
                                    style={{ float: "right" }}
                                    value={data?.student?.Codigo || "0"}
                                    onChange={(e) => {
                                      const selected = options.find((opt) => opt.value === e.target.value);
                                      this.setState(
                                        {
                                          department: selected?.label || "",
                                          deptId: selected?.value || "",
                                        },
                                        () => handleEstudiantechange({ value: selected?.value })
                                      );
                                    }}
                                  >
                                    <option value="0" disabled>Seleccionar Estudiante</option>
                                    {options.map((opt) => (
                                      <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                      </option>
                                    ))}
                                  </select>

                                </>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <>
                      <div className="col-11">
                        <ListaEestudiante
                          objStudents={
                            data == undefined
                              ? ""
                              : data.student == undefined
                              ? ""
                              : data.student
                          }
                        />
                      </div>
                      <div className="form-group col-12 mt-3">
                        {options != undefined ? (
                          options.length != 1 ? (
                            <>
                              <div
                                style={{
                                  fontSize: "1.5ex",
                                  padding: "0 0 0.5% 0",
                                }}
                              >
                                Cambiar de estudiante :
                              </div>

                              <select
                                className="form-select"
                                value={data?.student?.Codigo || "0"}
                                onChange={(e) => handleEstudiantechange({ value: e.target.value })}
                              >
                                <option value="0" disabled>Seleccionar Estudiante</option>
                                {options.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </option>
                                ))}
                              </select>
                            </>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className=" divisor-body mt-2 mb-3"></div>
          </div>
        )}
      </div>
    );
  }
}
